<template>
	<button class="btn-blue" v-on="$listeners" :disabled="disabled">
		<span>{{ $t('general.next') }}</span>
	</button>
</template>

<script>
export default {
	name: 'BaseContinueButton',
	props: {
		disabled: { default: false },
	},
};
</script>

<style lang="sass" scoped></style>
